module.exports = __webpack_public_path__ + "static/media/slide2.41f33c1f.jpg";